import React, {useState} from 'react';
import {Button, Card, Form, Input, message, Select, Row, Col, Modal} from 'antd';
import SearchVehicle from "../../../components/SearchVehicle";
import {SaveOutlined, PlusOutlined, CloseOutlined} from "@ant-design/icons";
import {
    useGetNotificationsQuery,
    useNewNotificationMutation
} from "../../../slices/rootApiSlices/notificaitonsApiSlice";
import {useSelector} from "react-redux";
import parameterList from "./parameterList";
import SearchUsers from "../../../components/SearchUsers";


const NotificationAddModal = ({visible, onClose}) => {

    const [form] = Form.useForm();
    const [forms, setForms] = useState([{id: Date.now(), parameter: ""}]);
    const {user} = useSelector(state => state.auth);
    const [newNotification, {isLoading}] = useNewNotificationMutation();
    const {refetch} = useGetNotificationsQuery(user?.token);

    const onFinish = async () => {
        try {
            const allNotifications = forms.map(formItem => {
                const formData = form.getFieldsValue([
                    `parameter_${formItem.id}`,
                    `thresholdValue_${formItem.id}`,
                    `thresholdOperator_${formItem.id}`,
                    `email_${formItem.id}`,
                    `notificationMethod_${formItem.id}`,
                    `vehicleID_${formItem.id}`,
                    `plateNumber_${formItem.id}`,
                    `isActive_${formItem.id}`,
                    `user_${formItem.id}`,
                    `targetUserID_${formItem.id}`,
                ]);
                return {
                    parameter: formData[`parameter_${formItem.id}`],
                    threshold_value: formData[`thresholdValue_${formItem.id}`],
                    threshold_operator: formData[`thresholdOperator_${formItem.id}`] || '>',
                    email: formData[`email_${formItem.id}`],
                    notification_method: formData[`notificationMethod_${formItem.id}`],
                    vehicle_id: formData[`vehicleID_${formItem.id}`],
                    plateNumber: formData[`plateNumber_${formItem.id}`],
                    isActive: formData[`isActive_${formItem.id}`],
                    target_user_id: formData[`user_${formItem.id}`],
                };
            });
            await newNotification({
                token: user?.token,
                data: allNotifications,
            }).unwrap();
            message.success(`${allNotifications.length} bildirim başarıyla eklendi.`, 5);
            refetch();
            form.resetFields();
            onClose();
        } catch (e) {
            console.error('Bildirim ekleme sırasında hata:', e);
            message.error(e?.data?.messageTR || 'Bir hata oluştu. Lütfen tekrar deneyiniz.', 5);
        }
    };

    const addForm = () => {
        setForms([...forms, {id: Date.now(), parameter: ""}]);
    };

    const removeForm = (id) => {
        setForms(forms.filter(formItem => formItem.id !== id));
    };

    const handleParameterChange = (value, formItem) => {
        const updatedForms = forms.map(item =>
            item.id === formItem.id ? {...item, parameter: value} : item
        );
        setForms(updatedForms);
        form.setFieldsValue({
            [`thresholdValue_${formItem.id}`]: undefined,
            [`thresholdOperator_${formItem.id}`]: undefined
        });
    };

    const isThresholdWarningOrError = (parameter) => {
        return parameterList.some(item => item.value === parameter && parameter.startsWith("TT"));
    };

    const {Option} = Select;

    return (
        <Modal
            title="Yeni Bildirimler Ekle"
            open={visible}
            onCancel={onClose}
            width={1000}
            footer={[
                <Button key="add" type="dashed" onClick={addForm} style={{width: '95%', marginBottom: 8}}>
                    <PlusOutlined/> Yeni Bildirim Ekle
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    onClick={onFinish}
                    icon={<SaveOutlined/>}
                    style={{width: '100%'}}>
                    Kaydet
                </Button>
            ]}
        >
            <Form form={form} layout="horizontal">
                {forms.map((formItem, index) => (
                    <Card
                        key={formItem.id}
                        type="inner"
                        size="small"
                        bordered={true}
                        style={{marginBottom: 8, position: 'relative'}}
                        title={`Bildirim ${index + 1}`}
                        extra={forms.length > 1 && (
                            <Button
                                type="text"
                                icon={<CloseOutlined/>}
                                onClick={() => removeForm(formItem.id)}
                            />
                        )}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Parametre"
                                    name={`parameter_${formItem.id}`}
                                    labelCol={{span: 8}}
                                    wrapperCol={{span: 16}}
                                    rules={[{required: true, message: 'Lütfen parametre seçiniz!'}]}
                                >
                                    <Select
                                        placeholder="Parametre"
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        disabled={isLoading}
                                        onChange={(value) => handleParameterChange(value, formItem)}
                                    >
                                        {parameterList.map((item, index) => (
                                            <Option key={index} value={item.value}>
                                                {item.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                {isThresholdWarningOrError(formItem.parameter) ? (
                                    <Form.Item label="Treshold Değeri" name={`thresholdValue_${formItem.id}`}
                                               labelCol={{span: 8}}
                                               wrapperCol={{span: 16}}
                                               rules={[{required: true, message: 'Lütfen arıza veya uyarı seçiniz!'}]}>
                                        <Select placeholder="Arıza/Uyarı Seç" disabled={isLoading}>
                                            <Option value={1}>Uyarı</Option>
                                            <Option value={2}>Arıza</Option>
                                        </Select>
                                    </Form.Item>
                                ) : (
                                    <Form.Item label="Treshold Değeri" name={`thresholdValue_${formItem.id}`}
                                               labelCol={{span: 8}}
                                               wrapperCol={{span: 16}}
                                               rules={[{required: true, message: 'Lütfen treshold değeri giriniz!'}]}>
                                        <Input placeholder="Treshold Değeri" disabled={isLoading}/>
                                    </Form.Item>
                                )}
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Treshold Operatörü" name={`thresholdOperator_${formItem.id}`}
                                           labelCol={{span: 8}}
                                           wrapperCol={{span: 16}}
                                           rules={[{required: true, message: 'Lütfen operatör seçiniz!'}]}>
                                    <Select placeholder="Operatör" allowClear
                                            disabled={isLoading || isThresholdWarningOrError(formItem.parameter)}>
                                        <Option value=">">Büyüktür</Option>
                                        <Option value="<">Küçüktür</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Kullanıcı"
                                    name={`email_${formItem.id}`}
                                    labelCol={{span: 8}}
                                    wrapperCol={{span: 16}}
                                    rules={[{required: true, message: 'Lütfen kullanıcı seçiniz!'}]}
                                >
                                    <SearchUsers
                                        onChange={(selectedUser) => {
                                            form.setFieldsValue({
                                                [`email_${formItem.id}`]: selectedUser.value,
                                                [`user_${formItem.id}`]: selectedUser.key
                                            });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Bildirim Türü" name={`notificationMethod_${formItem.id}`}
                                           labelCol={{span: 8}}
                                           wrapperCol={{span: 16}}
                                           rules={[{required: true, message: 'Lütfen bildirim türünü seçiniz!'}]}>
                                    <Select placeholder="Bildirim Türü" allowClear disabled={isLoading}>
                                        <Option value="push">Web Push Bildirimi</Option>
                                        <Option value="email">E-posta</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Durum"
                                    name={`isActive_${formItem.id}`}
                                    labelCol={{span: 8}}
                                    wrapperCol={{span: 16}}
                                    rules={[{required: true, message: 'Lütfen durum seçiniz!'}]}
                                >
                                    <Select placeholder="Durum" allowClear disabled={isLoading}>
                                        <Option value={true}>Aktif</Option>
                                        <Option value={false}>Pasif</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Araç"
                                    name={`vehicleID_${formItem.id}`}
                                    labelCol={{span: 8}}
                                    wrapperCol={{span: 16}}
                                    rules={[{required: true, message: 'Lütfen araç seçiniz!'}]}
                                >
                                    <SearchVehicle
                                        onChange={(selectedVehicle) => {
                                            form.setFieldsValue({
                                                [`vehicleID_${formItem.id}`]: selectedVehicle.device_id,
                                                [`plateNumber_${formItem.id}`]: selectedVehicle.plateNumber
                                            });
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                ))}
            </Form>
        </Modal>
    );
};

export default NotificationAddModal;
